import { defineComponent } from "vue";
import useNavigation from "@/composables/navigation";
export default defineComponent({
    name: "NavigationButton",
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const { isMenuOpen, toggleMenu } = useNavigation();
        return {
            isMenuOpen,
            toggleMenu,
        };
    },
});
